// extracted by mini-css-extract-plugin
export default {"footerToolbar":"BtlSD","footerToolbar_buttons":"aIH2m","footerToolbarButtons":"aIH2m","wrapper":"ygLFk","desktop":"iTcNr","editor":"PFd+L","atomic":"r-319"};